export const audienceGroup = {
  edit: "Edit Audience Group",
  create: "Create Audience Group",
  groupName: "Group Name",
  subheading: "Subheading (Optional)",
  subheadingPlaceholder: "e.g., Healthcare professionals, Community leaders",
  subheadingHelper: "A short descriptive phrase that appears below the group name",
  description: "Description",
  descriptionRequired: "Description is required",
  color: "Color"
}
